import React, { Dispatch, useEffect } from 'react';
import { FormSelectField } from '../../../../common/form/form-select-field';
import { useTranslation } from 'react-i18next';
import { useBusinessGroups } from '../../../../../graphql/graph-hooks';
import { toast } from 'react-toastify';

interface BusinessGroupSelectProps {
  isDisabled: boolean,
  id: string,
  name: string,
  value: string,
  handleChange: Dispatch<{target: {name: string, value: string}}>,
}

const BusinessGroupSelect: React.FC<BusinessGroupSelectProps> = (props) => {
  const { isDisabled, value, id, name, handleChange } = props;
  const { t } = useTranslation();

  // Fetch business groups
  const { loading, error, data } = useBusinessGroups();

  const options = (data?.business_groups?.nodes || []).map((group) => ({
    label: group.name,
    value: group.id
  }));

  const businessGroupOptions = [
    { label: t('common.select'), value: '' },
    ...options
  ];

  useEffect(() => {
    if (error) {
      toast.error(t(`${t('businessGroupsPage.error_fetching_groups')}: ${error?.message}`));
    }
  }, [error]);

  return (
    <div>
      <FormSelectField
        id={id}
        label={t('clubPage.businessGroup')}
        name={name}
        value={value}
        isDisabled={isDisabled || loading}
        options={businessGroupOptions}
        handleChange={handleChange}
      />
    </div>
  );
};

export { BusinessGroupSelect };
